import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=590a71c0&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a71c0",
  null
  
)

export default component.exports